import { Outlet } from 'react-router-dom'
import { ConfigProvider, Layout, theme } from "antd"
import { HeaderComponent } from "./HeaderComponent.tsx"
import { Modals } from "./Modals.tsx"
import { useDarkMode } from "../hooks/useDarkMode.tsx"
import { useQueryInvalidationSubscription } from "../hooks/useQueryInvalidationSubscription.tsx"

const { Content } = Layout
const { useToken } = theme

export const LayoutComponent = () => {
    const { token } = useToken()
    const { contextHolder } = useQueryInvalidationSubscription()
    const { darkModeEnabled } = useDarkMode()

    return (
        <ConfigProvider
            theme={{
                algorithm: darkModeEnabled ? theme.darkAlgorithm : theme.defaultAlgorithm,
                cssVar: true,
                token: {
                    borderRadius: 6,
                    colorBgElevated: darkModeEnabled ? '#1F1F1F' : '#F5F5F5'
                },
                components: {
                    Divider: {
                        marginLG: 0,
                        margin: 0
                    },
                    Tag: {
                        marginXS: 4
                    }
                },
            }}
        >
            {contextHolder}
            <Layout style={{
                height: '100vh', background: token.colorBgBase, width: '100%', display: 'flex', overflow: 'hidden'
            }}>
                <Layout>
                    <HeaderComponent />
                    <Content
                        className="scroll"
                        style={{ overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <Outlet/>
                    </Content>
                    <Modals />
                </Layout>
            </Layout>
        </ConfigProvider>

    )
}
